import { z } from 'zod'
import { TYPEAHEAD_FIELD_TYPES } from '../consts'

export const fieldTypeSchema = z.enum(TYPEAHEAD_FIELD_TYPES)
export type FieldType = z.infer<typeof fieldTypeSchema>

export const typeaheadQueryParametersSchema = z.object({
  field: fieldTypeSchema,
  query: z.string(),
})
